module.exports = __webpack_public_path__ + "static/media/backgroundLogin.9af171c2.webp";